export function AllowedToWant() {
  return (
    <section
      data-testid="believing-happy-permission-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-14 md:py-16 reveal">
        <h2
          data-testid="believing-happy-permission-headline"
          className="font-display text-[34px] sm:text-[44px] lg:text-[50px] leading-[1.14] tracking-tight text-[#1C1917] max-w-2xl"
        >
          You are allowed to want your life to feel good.
        </h2>

        <div className="mt-6 space-y-1 text-lg md:text-xl leading-relaxed text-[#1C1917]">
          <p>Not impressive.</p>
          <p>Not productive.</p>
          <p>Not enviable from across the internet.</p>
          <p className="text-[#159E9A]">Good to you.</p>
        </div>

        <div className="mt-6 space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl">
          <p>
            You can be grateful for what you have and curious about what
            else might be possible.
          </p>
          <p>
            You can love people deeply and still need something that&rsquo;s
            yours.
          </p>
          <p>
            You can change your mind.
            <br />
            You can outgrow an old dream.
          </p>
          <p>
            You can want more adventure.
            <br />
            More quiet.
            <br />
            More laughter.
            <br />
            More meaning.
            <br />
            More Tuesday afternoons that don&rsquo;t feel like something to
            get through.
          </p>
        </div>

        <p
          data-testid="believing-happy-permission-closing-line"
          className="mt-8 font-display italic text-2xl md:text-3xl leading-snug text-[#159E9A] max-w-xl"
        >
          Wanting to feel more like yourself is reason enough.
        </p>
      </div>
    </section>
  );
}
